
import { Action             } from "@/models/action";
import { ActionType         } from "@/models/action.type";

import { LeafletControls    } from "@/components/leaflet/leaflet.controls";

export class ShowLeafletControlbar extends Action {

  /** the panoramic controller that can actually do stuff for us */
  private readonly _controller : LeafletControls = null;

  /** standard constructor */
  constructor(controller : LeafletControls) {
    super({
      key:   ActionType.LEAFLET_CONTROLS_SHOW,
      type:  ActionType.LEAFLET_CONTROLS_SHOW,
      label: 'Show Leaflet Controls',
      icon:  '',
      tip:   ''
    });

    this._controller = controller;
  }

  /** fetch the panoramic controller */
  public controller(): LeafletControls {

    return this._controller;
  }

  /** implement the action */
  public execute() : boolean {

    this._controller.showControls();

    return true;
  }
}
